import { Component, ElementRef, Injector, afterNextRender, computed, effect, inject, input, output, signal, viewChild } from '@angular/core';
import { DrawerVm, RerunFeedback } from '../agent-runs.models';

@Component({
  selector: 'app-agent-run-drawer',
  templateUrl: './agent-run-drawer.component.html',
  styleUrl: './agent-run-drawer.component.scss',
})
export class AgentRunDrawerComponent {
  private _injector = inject(Injector);
  private _stopButton = viewChild<ElementRef<HTMLButtonElement>>('stopButton');
  private _keepRunningButton = viewChild<ElementRef<HTMLButtonElement>>('keepRunningButton');

  open = input<boolean>(false);
  vm = input<DrawerVm | null>(null);
  rerunFeedback = input<RerunFeedback | null>(null);

  closed = output<void>();
  rerunRequested = output<void>();
  stopRequested = output<void>();

  // Stopping can't be undone, so the first click asks for confirmation.
  confirmingStop = signal<boolean>(false);

  // Background refreshes rebuild the view model; only a different run or lost eligibility closes the confirmation.
  private _stopTarget = computed(() => {
    const vm = this.vm();
    return vm ? `${vm.run.agentRunId}:${vm.canStop}` : null;
  });

  constructor() {
    effect(() => {
      this._stopTarget();
      this.confirmingStop.set(false);
    });
  }

  // Focus the safe choice so keyboard and screen-reader users land inside the confirmation.
  openStopConfirm(): void {
    this.confirmingStop.set(true);
    afterNextRender(() => this._keepRunningButton()?.nativeElement.focus(), { injector: this._injector });
  }

  cancelStopConfirm(): void {
    this.confirmingStop.set(false);
    afterNextRender(() => this._stopButton()?.nativeElement.focus(), { injector: this._injector });
  }

  confirmStop(): void {
    this.confirmingStop.set(false);
    this.stopRequested.emit();
  }
}
